import { Base64 } from 'js-base64';
import api from 'api';

// upload a single entry to server by local storage key
const uploadEntry = async ({ courseId, type, packet }) => {
  const url = {
    analytics: '/reader/analytics/user-analytics',
    'course-access': '/reader/analytics/course-analytics',
    search: '/reader/analytics/search-analytics'
  }[type];
  if (!url) return Promise.resolve();

  try {
    const response = await api.post(`${url}?courseId=${courseId}`, {
      encodedData: Base64.encode(JSON.stringify(packet.data))
    });
    if (response.data?.success) {
      packet.keys.forEach((key) => {
        localStorage.removeItem(key);
      });
    }
  } catch (err) {
    // do nothing
  } finally {
    const referenceKeys = JSON.parse(
      localStorage.getItem('vuoAnalyticsReferenceKeys') || '{}'
    );
    packet.keys.forEach((key) => {
      delete referenceKeys[key];
    });

    localStorage.setItem(
      'vuoAnalyticsReferenceKeys',
      JSON.stringify(referenceKeys)
    );
  }
};

export default uploadEntry;
